import React, { useEffect, useState } from "react";

// Static import for root styles - this must be imported directly
import "@vwpfs/mary-air-lib/assets/stylesheets/themes/vwpfs/air/root";


import FavIcon from "../assets/images/themes/vwpfs/icons/favicon.ico";
import { setThemeReferences } from "./_utils";
import { Themes } from "@vwpfs/mary-air-lib/theme/_Types";
import { PageLoader } from "./07-organisms/PageLoader";

const loadStyles = async () => {
    await Promise.all([
        // Pure Mary Air styles - dynamic imports
        import("@vwpfs/mary-air-lib/assets/stylesheets/themes/vwpfs/air/main"),
        import("@vwpfs/mary-air-lib/assets/stylesheets/themes/vwpfs/air/fonts"),

        // Custom Extended Warranty System styles
        import("./assets/stylesheets/themes/vwpfs/index.scss"),
    ]);
};

const MainTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    console.info(isLoading ? "VWPFS Theme is loading..." : "VWPFS Theme has finished loading");

    if (hasError) {
        console.error("VWPFS Theme cannot be loaded");
    }

    useEffect(() => {
        loadStyles()
            .then(() => {
                console.log("Mary Air CSS loaded successfully");
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                setHasError(true);
            });
    }, []);

    useEffect(() => {
        setThemeReferences(Themes.VWPFS, {
            favicon: FavIcon,
        });
    }, []);

    return (
        <>
            {isLoading && <PageLoader />}
            <div style={{ visibility: isLoading ? "hidden" : "visible" }}>
                {children}
            </div>
        </>
    );
};

export default MainTheme;
